import React, { useEffect, useState } from 'react';

import { formatDateRangeString } from 'common/actions/userQueries';
import AJAX from 'common/AJAX';
import Spinner from 'common/Spinner';
import numberWithCommas from 'common/util/numberWithCommas';
import parseAPIResponse from 'common/util/parseAPIResponse';

type Props = {
  userList: {
    queryParams?: Record<string, string>;
  };
  trackedUserCount: number;
};

const AdminUserCount = ({ userList, trackedUserCount }: Props) => {
  const [userCount, setUserCount] = useState<number>(NaN);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const response = await AJAX.post('/api/users/count', {
        dateRange:
          userList.queryParams?.dateRange && formatDateRangeString(userList.queryParams.dateRange),
        search: userList.queryParams?.search,
        segmentURLName: userList.queryParams?.segmentURLName,
        sort: userList.queryParams?.sort,
      });

      const { error, parsedResponse } = parseAPIResponse<{ result: number }>(response, {
        isSuccessful: (parsedResponse) =>
          parsedResponse && typeof parsedResponse.result === 'number',
      });

      setLoading(false);
      if (error || !parsedResponse) {
        setUserCount(NaN);
        return;
      }

      setUserCount(parsedResponse.result);
    };

    if (userList?.queryParams) {
      fetch();
    }
  }, [userList.queryParams]);

  if (loading) {
    return (
      <div className="userCount">
        <Spinner />
      </div>
    );
  }

  const { queryParams } = userList;
  const shouldShowTrackedUsers =
    !queryParams?.search && !queryParams?.segmentURLName && !queryParams?.dateRange;
  const trackedUsers = shouldShowTrackedUsers
    ? ` (${numberWithCommas(trackedUserCount)} tracked users)`
    : null;

  const users = userCount === 1 ? 'User' : 'Users';
  return (
    <div className="userCount">
      {Number.isNaN(userCount) ? '—' : numberWithCommas(userCount)} {users}
      {trackedUsers}
    </div>
  );
};

export default AdminUserCount;
